export default "__VITE_ASSET__n9iCpCQi__"